import { useTranslate } from "@similarweb/i18n-provider";

import { PlaybookConfirmationModal } from "../PlaybookConfirmationModal/PlaybookConfirmationModal";

type EditSharedPlaybookModalProps = {
    isOpen: boolean;
    onCancel: () => void;
    onConfirm: () => void;
};

export const EditSharedPlaybookModal = ({ isOpen, onCancel, onConfirm }: EditSharedPlaybookModalProps) => {
    const { translate } = useTranslate();

    return (
        <PlaybookConfirmationModal
            isOpen={isOpen}
            title={translate("si.playbooks.edit.shared.title")}
            description={translate("si.playbooks.edit.shared.description")}
            confirmLabel={translate("si.playbooks.edit.shared.confirm")}
            confirmButtonType="primary"
            onCancel={onCancel}
            onConfirm={onConfirm}
            dataAutomation="edit-shared-playbook-modal"
        />
    );
};
